import React, { useEffect, useState } from 'react';
import { Button } from 'reactstrap';
import AUX from '../../../hoc/Aux_';
import { useDispatch, useSelector } from 'react-redux';
import {
  getMember,
  getProjects,
  getProjectTaskById,
  updateProjectTask,
} from '../../../redux/MainAction';
import moment from 'moment';
import Select from 'react-select';

const EditTask = ({ open, onClose, ID }) => {
  const dispatch = useDispatch();
  const single = useSelector((state) => state?.Webtracker?.projectTaskById);
  const tmlist = useSelector((state) => state.Webtracker.member);
  const prjlist = useSelector((state) => state.Webtracker.projects);

  const [empDataOption, setEmpDataOption] = useState([]);
  const [empDataValue, setEmpDataValue] = useState([]);

  const [editData, setEditData] = useState({
    priority: 'URGENT',
    name: '',
    projectId: '',
    description: '',
    startDate: '',
    endDate: '',
    timeEstimate: '',
    budgetEstimate: '',
    taskStatus: '',
    status: '',
  });
  const onChangeData = (e) => {
    const { name, value } = e.target;
    setEditData({ ...editData, [name]: value });
  };

  useEffect(() => {
    if (ID) getList();
  }, [ID]);

  const getList = () => {
    var data = {
      id: ID,
    };
    dispatch(getProjectTaskById(data));
    // dispatch(getMember());
    // dispatch(getProjects());
  };
  const onEmployeeChange = (value) => {
    if (value) {
      setEmpDataValue(value);
    }
  };
  useEffect(() => {
    if (tmlist && tmlist?.rows) {
      const option = tmlist?.rows?.map((user) => {
        return {
          label: `${user?.firstName} ${user?.lastName}`,
          value: user?.id,
        };
      });
      setEmpDataOption(option);
    }
  }, [tmlist]);

  useEffect(() => {
    if (single) {
      setEditData({
        priority: single?.priority,
        name: single?.name,
        description: single?.description,
        projectId: single?.projectId,
        startDate: moment(single?.startDate).format('YYYY-MM-DD'),
        endDate: moment(single?.endDate).format('YYYY-MM-DD'),
        timeEstimate: single?.timeEstimate,
        budgetEstimate: single?.budgetEstimate,
        taskStatus: single?.taskStatus,
        status: single?.status,
      });
      const option = single?.projectTaskMembers?.map((user) => {
        return {
          label: `${user?.projectTaskEmployee?.firstName} ${user?.projectTaskEmployee?.lastName}`,
          value: user?.projectTaskEmployee?.id,
        };
      });
      setEmpDataValue(option);
    }
  }, [single]);

  const onSaveHandle = (e) => {
    e.preventDefault();

    const employeeIdsAr = empDataValue?.map((item) => item?.value);
    const payload = {
      id: ID,
      name: editData?.name,
    };

    if (editData?.priority !== '') {
      payload.priority = editData?.priority;
    }
    if (editData?.budgetEstimate !== '' && editData?.budgetEstimate !== null) {
      payload.budgetEstimate = editData?.budgetEstimate;
    }
    if (editData?.timeEstimate !== '' && editData?.timeEstimate !== null) {
      payload.timeEstimate = editData?.timeEstimate;
    }
    if (editData?.description !== '' && editData?.description !== null) {
      payload.description = editData?.description;
    }
    if (editData?.startDate !== '' && editData?.startDate !== 'Invalid date') {
      payload.startDate = editData?.startDate;
    }
    if (editData?.endDate !== '' && editData?.endDate !== 'Invalid date') {
      payload.endDate = editData?.endDate;
    }
    if (editData?.taskStatus !== '') {
      payload.taskStatus = editData?.taskStatus;
    }
    if (editData?.status !== '') {
      payload.status = editData?.status;
    }
    if (employeeIdsAr?.length > 0) {
      payload.employeeIds = employeeIdsAr;
    } else {
      payload.employeeIds = [];
    }

    dispatch(updateProjectTask(payload));
    onClose();
  };

  return (
    <AUX>
      <div className="page-content-wrapper">
        <div className="container-fluid">
          <div className={`overlay ${open ? 'open' : ''}`} id="myNav">
            <div className="overlay-content">
              <div className="overlay_container">
                <div className="d-flex justify-content-between align-items-center">
                  <h6>Edit Task</h6>
                  <div
                    className="d-flex justify-content-end "
                    style={{ margin: '10px 38px', gap: '20px' }}
                  >
                    <Button
                      outline
                      size="sm"
                      color="primary"
                      onClick={onSaveHandle}
                    >
                      <i className="fa fa-save mr-1"></i>
                      Save
                    </Button>
                    <i
                      className="mdi mdi-close"
                      onClick={onClose}
                      style={{ fontSize: '22px', cursor: 'pointer' }}
                    />
                  </div>
                </div>
                <div className="row col-12">
                  <div className="form-group col-6">
                    <label for="username1" className="font-14 text-muted ">
                      Name <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="Enter Name"
                      className="form-control"
                      name="name"
                      value={editData?.name}
                      onChange={onChangeData}
                      id="username1"
                    />
                  </div>
                  <div className="form-group col-6">
                    <label className="text-muted">Task Priority</label>
                    <div className="">
                      <select
                        className="form-control"
                        name="priority"
                        value={editData?.priority}
                        onChange={onChangeData}
                      >
                        {/* <option>Select Priority</option> */}
                        <option value="URGENT">Urgent</option>
                        <option value="HIGH">High</option>
                        <option value="NORMAL">Normal</option>
                        <option value="LOW">Low</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div
                  className=" form-group"
                  style={{ marginLeft: '10px', width: '94%' }}
                >
                  <label className="control-label">Select Member</label>
                  <Select
                    value={empDataValue}
                    onChange={onEmployeeChange}
                    options={empDataOption}
                    isMulti={true}
                  />
                </div>

                <div className="row col-12">
                  <div className="form-group col-6">
                    <label for="D14" className="font-14 text-muted ">
                      Estimate Time
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      name="timeEstimate"
                      value={editData?.timeEstimate}
                      onChange={onChangeData}
                      id="D4"
                    />
                  </div>
                  <div className="form-group col-6">
                    <label for="D5" className="font-14 text-muted ">
                      Estimate Budget
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      name="budgetEstimate"
                      value={editData?.budgetEstimate}
                      onChange={onChangeData}
                      id="D5"
                    />
                  </div>
                </div>

                <div className="row col-12">
                  <div className="form-group col-12">
                    <label className="text-muted">Select Project</label>
                    <select
                      className="form-control"
                      name="priority"
                      value={editData?.projectId}
                      onChange={onChangeData}
                    >
                      {prjlist?.rows?.map((itm, idx) => (
                        <option key={idx} value={itm?.id}>
                          {itm?.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="row col-12">
                  <div className="form-group col-6">
                    <label for="D1" className="font-14 text-muted ">
                      Start Date
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      name="startDate"
                      value={editData?.startDate}
                      onChange={onChangeData}
                      id="D1"
                    />
                  </div>
                  <div className="form-group col-6">
                    <label for="D2" className="font-14 text-muted ">
                      End Date
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      name="endDate"
                      value={editData?.endDate}
                      onChange={onChangeData}
                      id="D2"
                    />
                  </div>
                </div>
                <div className="row col-12">
                  <div className="form-group col-6">
                    <label className="text-muted">Task Status</label>
                    <div className="">
                      <select
                        className="form-control"
                        name="taskStatus"
                        value={editData?.taskStatus}
                        onChange={onChangeData}
                      >
                        <option value="OPEN">Open</option>
                        <option value="IN-PROGRESS">In Progress</option>
                        <option value="DONE">Done</option>
                        <option value="CLOSED">Closed</option>
                      </select>
                    </div>
                  </div>
                  <div className="form-group col-6">
                    <label className="text-muted">Status</label>
                    <div className="">
                      <select
                        className="form-control"
                        name="status"
                        value={editData?.status}
                        onChange={onChangeData}
                      >
                        <option value="ACTIVE">Active</option>
                        <option value="INACTIVE">Inactive</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="row col-12">
                  <div className="form-group col-12">
                    <label>Description</label>
                    <textarea
                      type="text"
                      className="form-control"
                      name="description"
                      value={editData?.description}
                      onChange={onChangeData}
                      rows={4}
                      placeholder=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AUX>
  );
};

export default EditTask;
